module.exports = __webpack_public_path__ + "static/lemonanimalmain-f1efd121aae0cfd2141b369018c25382.png";